import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Grid,
  Tooltip
} from "@mui/material";
import React from "react";

export const classNames = {
  title: "modalTitle"
};

export interface IModal extends DialogProps {
  isLoading?: boolean;
  confirmDisabled?: boolean;
  confirmDisabledTooltip?: string;
  confirmSpinner?: boolean;
  handleClose?: () => void;
  handleConfirm?: () => void;
  title: string;
  children?: React.ReactNode;
}

const Modal: React.FC<IModal> = ({
  confirmDisabled = false,
  confirmDisabledTooltip = "",
  confirmSpinner = false,
  isLoading = false,
  title,
  handleClose,
  handleConfirm,
  children,
  ...rest
}) => {
  return (
    <Dialog {...rest} onClose={(_, reason) => reason !== "backdropClick" && handleClose && handleClose()}>
      <DialogTitle className={classNames.title}>{title}</DialogTitle>
      {!isLoading ? (
        <>
          <DialogContent>{children}</DialogContent>
          <DialogActions>
            <Grid container justifyContent="end" spacing={1}>
              {handleClose && (
                <Grid item>
                  <Button disabled={confirmSpinner} onClick={handleClose} color="secondary">
                    Cancel
                  </Button>
                </Grid>
              )}
              {handleConfirm && (
                <Grid item>
                  <Tooltip title={confirmDisabled ? confirmDisabledTooltip : ""} placement="top">
                    <span>
                      {confirmSpinner ? (
                        <Box px={1}>
                          <CircularProgress />
                        </Box>
                      ) : (
                        <Button onClick={handleConfirm} disabled={confirmDisabled}>
                          OK
                        </Button>
                      )}
                    </span>
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          </DialogActions>
        </>
      ) : (
        <Grid container justifyContent="center">
          <Box m={5}>
            <CircularProgress />
          </Box>
        </Grid>
      )}
    </Dialog>
  );
};

export default Modal;
